<template>
  <b-container v-if="$store.state.logged">
    <b-row>
      <b-col cols="10">
        <LiveNavigation :currentTab="subtab" @changeLiveTab="changeLiveTab"></LiveNavigation>
      </b-col>
      <b-col cols="2" class="spinner_col" v-if="$store.state.module.live_en_cours && $store.state.fin_selected_course === 'NON'">
        <SpinnerLive></SpinnerLive>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12" class="content_container">
        <transition name="fade">
          <ListParticipants v-if="subtab === 'participants'"></ListParticipants>
        </transition>
        <transition name="fade">
          <Passages v-if="subtab === 'passages'"></Passages>
        </transition>
        <transition name="fade">
          <Podiums v-if="subtab === 'podium'"></Podiums>
        </transition>
        <transition name="fade">
          <CarteLive v-if="subtab === 'carte_live'"></CarteLive>
        </transition>
        <transition name="fade">
          <Webcams v-if="subtab === 'webcams'"></Webcams>
        </transition>
        <transition name="fade">
          <Favoris v-if="subtab === 'favoris'"></Favoris>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import SpinnerLive from "@/components/Live_tab/SpinnerLive.vue";
import LiveNavigation from "@/components/Live_tab/LiveNavigation.vue";
import ListParticipants from "@/components/Live_tab/PCCourse/ListParticipantsPaginated.vue";

import Podiums from "@/components/Live_tab/Podiums.vue";
import CarteLive from "@/components/Live_tab/CarteLive.vue";
import Passages from "@/components/Live_tab/Passages.vue";
import Webcams from "@/components/Live_tab/Webcams.vue";
import Favoris from "@/components/Live_tab/Favoris.vue";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    LiveNavigation,
    ListParticipants,
    Podiums,
    Passages,
    CarteLive,
    Loading,
    SpinnerLive,
    Webcams,
    Favoris,
  },
  data() {
    return {
      subtab: "participants",
      listCourses: [],
      updateIn: 90,
    };
  },
  methods: {
    changeLiveTab(t) {
      this.subtab = t;
    },
    getListCourses(data) {
      for (var i = 0; i < data.list_participants.length; i++) {
        if (!this.listCourses.includes(data.list_participants[i].course)) {
          this.listCourses.push(data.list_participants[i].course);
        }
      }
    },
    async checkIfLoggedUser() {
      var _this = this;
      await axios
        .get("https://sportips.fr/" + this.$route.params.base + "/admin/index.php")
        .then(function (response) {
          _this.$store.state.logged = true;
          let key = "pc_course_" + _this.$store.state.module.base;
          if (_this.$cookies.isKey(key)) {
            _this.$cookies.remove(key);
          } else {
            _this.$cookies.set(key, 1);
          }
          _this.$router.push({ name: "Live" });
        })
        .catch(function (error) {
          _this.$store.state.logged = true;
          let key = "pc_course_" + _this.$store.state.module.base;
          if (_this.$cookies.isKey(key)) {
            _this.$cookies.remove(key);
          } else {
            _this.$cookies.set(key, 1);
          }
          /* _this.$router.push({ name: "Courses" }); */
        });
    },
  },
  async created() {
    if (this.$store.state.logged) {
      let key = "pc_course_" + this.$store.state.module.base;
      if (this.$cookies.isKey(key)) {
        this.$cookies.remove(key);
      }
      this.$store.state.logged = false;
      this.$router.push({ name: "Courses" });
      this.$forceUpdate();
    } else {
      await this.checkIfLoggedUser();
      this.subtab = this.$store.state.last_live_tab;
    }
  },
};
</script>

<style lang="sass">
</style>